import classNames from "./CompaniesSlider.module.css";
// import linkedinImg from "../../../assets/companies/linkedin.svg";
// import uberImg from "../../../assets/companies/uber.svg";
import byrneImg from "../../../assets/companies/byrne.svg";
import atlasCopcoImg from "../../../assets/companies/atlas_copco.svg";
// import nerdwalletImg from "../../../assets/companies/nerdwallet.webp";
// import nacImg from "../../../assets/companies/nac.webp";
// import threatmarkImg from "../../../assets/companies/threatmark.svg";
// import universityOfWaterlooImg from "../../../assets/companies/university_of_waterloo.webp";
import rocheImg from "../../../assets/companies/roche.webp";
// import columbiaUniversityImg from "../../../assets/companies/columbia_university.webp";
// import hycImg from "../../../assets/companies/hyc.svg";
// import docusignImg from "../../../assets/companies/docusign.webp";
// import indeedImg from "../../../assets/companies/indeed.webp";
import meetsmoreImg from "../../../assets/companies/meetsmore.webp";
import forgeworksImg from "../../../assets/companies/forgeworks.webp";
import filuetImg from "../../../assets/companies/filuet.webp";
import velvacImg from "../../../assets/companies/velvac.webp";

const companies = [
  // {
  //   name: "Linkedin",
  //   image: linkedinImg,
  // },
  // {
  //   name: "Uber",
  //   image: uberImg,
  // },
  {
    name: "Byrne",
    image: byrneImg,
  },
  {
    name: "Atlas Copco",
    image: atlasCopcoImg,
  },
  // {
  //   name: "Nerdwallet",
  //   image: nerdwalletImg,
  // },
  // {
  //   name: "New Apostolic Church",
  //   image: nacImg,
  // },
  // {
  //   name: "Threatmark",
  //   image: threatmarkImg,
  // },
  // {
  //   name: "University of Waterloo",
  //   image: universityOfWaterlooImg,
  // },
  {
    name: "Roche",
    image: rocheImg,
  },
  // {
  //   name: "Columbia University",
  //   image: columbiaUniversityImg,
  // },
  // {
  //   name: "HY-C",
  //   image: hycImg,
  // },
  // {
  //   name: "DocuSign",
  //   image: docusignImg,
  // },
  // {
  //   name: "Indeed",
  //   image: indeedImg,
  // },
  {
    name: "Meetsmore",
    image: meetsmoreImg,
  },
  {
    name: "ForgeWorks",
    image: forgeworksImg,
  },
  {
    name: "Filuet",
    image: filuetImg,
  },
  {
    name: "Velvac",
    image: velvacImg,
  },
];

const CompaniesSlider = () => {
  return (
    <div className={classNames.Companies}>
      <div className={classNames.ImageSlider}>
        {/* {companies.concat(companies.reverse()).map((comapany, index) => (
          <img key={index} src={comapany.image} alt={comapany.name} />
        ))} */}
        {companies.map((comapany, index) => (
          <img key={index} src={comapany.image} alt={comapany.name} />
        ))}
      </div>
    </div>
  );
};

export default CompaniesSlider;
